import { render, staticRenderFns } from "./NewStockBasketDialog.vue?vue&type=template&id=110d4950"
import script from "./NewStockBasketDialog.vue?vue&type=script&lang=js"
export * from "./NewStockBasketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports